"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentStatus = exports.PaymentCurrency = exports.PaymentProvider = void 0;
var PaymentProvider;
(function (PaymentProvider) {
    PaymentProvider["STRIPE"] = "stripe";
    PaymentProvider["PAYPAL"] = "paypal";
})(PaymentProvider || (exports.PaymentProvider = PaymentProvider = {}));
var PaymentCurrency;
(function (PaymentCurrency) {
    PaymentCurrency["PLN"] = "pln";
    PaymentCurrency["EUR"] = "eur";
    PaymentCurrency["USD"] = "usd";
    PaymentCurrency["GBP"] = "gbp";
})(PaymentCurrency || (exports.PaymentCurrency = PaymentCurrency = {}));
var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus[PaymentStatus["PENDING"] = 1] = "PENDING";
    PaymentStatus[PaymentStatus["SUCCESS"] = 2] = "SUCCESS";
    PaymentStatus[PaymentStatus["REJECTED"] = 3] = "REJECTED";
    PaymentStatus[PaymentStatus["ERROR"] = 99] = "ERROR";
})(PaymentStatus || (exports.PaymentStatus = PaymentStatus = {}));
